import React from 'react';
import { Grid, TextField, Button, Typography, Divider, Box, Paper, FormControl, InputLabel, Select, MenuItem, ListSubheader, FormHelperText } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { doctorGroups } from '../constants/options';

const SignaturesSection = ({ 
  formData, 
  errors,
  handleInputChange,
  handleBlur,
  signatureDialogOpen, 
  signaturePadRef, 
  handleSignatureOpen, 
  handleSignatureClear, 
  handleSignatureSave, 
  handleSignatureClose 
}) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>Signatures</Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Grid container spacing={4} alignItems="flex-end">
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required error={!!errors.doctor_name}>
            <InputLabel>Doctor Name</InputLabel>
            <Select
              name="doctor_name"
              value={formData.doctor_name || ""}
              label="Doctor Name"
              onChange={handleInputChange}
              onBlur={handleBlur}
            >
              <MenuItem value=""><em>Select Doctor</em></MenuItem>
              {Object.entries(doctorGroups).map(([groupName, doctors]) => [
                <ListSubheader key={groupName}>{groupName}</ListSubheader>,
                ...doctors.map((doc, idx) => (
                  <MenuItem key={`${groupName}-${idx}`} value={doc}>{doc}</MenuItem>
                ))
              ])}
            </Select>
            {errors.doctor_name && <FormHelperText>{errors.doctor_name}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="subtitle2">Doctor Signature</Typography>
            {formData.doctor_name_signature ? (
              <Paper variant="outlined" sx={{ p: 1, backgroundColor: '#f9f9f9', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img 
                  src={`data:image/png;base64,${formData.doctor_name_signature}`} 
                  alt="Signature" 
                  style={{ maxHeight: '100px', maxWidth: '100%' }} 
                />
                <Button size="small" onClick={() => handleSignatureOpen('doctor_name_signature')} sx={{ mt: 1 }}>
                  Resign
                </Button>
              </Paper>
            ) : (
              <Button 
                variant="outlined" 
                fullWidth 
                onClick={() => handleSignatureOpen('doctor_name_signature')}
                sx={{ py: 3, borderStyle: 'dashed', color: errors.doctor_name_signature ? 'error.main' : 'primary.main', borderColor: errors.doctor_name_signature ? 'error.main' : 'primary.main' }}
              >
                Capture Signature
              </Button>
            )}
            {errors.doctor_name_signature && <Typography variant="caption" color="error">{errors.doctor_name_signature}</Typography>}
          </Box>
        </Grid>
      </Grid>

      {/* Signature Dialog */}
      <Dialog open={signatureDialogOpen} onClose={handleSignatureClose} maxWidth="sm" fullWidth>
        <DialogTitle>Provide Your Signature</DialogTitle>
        <DialogContent>
          <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', mt: 1 }}>
            <SignatureCanvas
              ref={signaturePadRef}
              penColor="black"
              canvasProps={{ width: 550, height: 200, className: 'sigCanvas' }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
          <Button onClick={handleSignatureClose}>Close</Button>
          <Button onClick={handleSignatureSave} variant="contained" color="primary">Done</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SignaturesSection;
